import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { orderBy } from 'lodash';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AvatarService } from 'src/app/common/service/avatar.service';
import { LangService } from 'src/app/common/service/lang.service';
import { UserProfileService } from 'src/app/common/service/user-profile.service';
import { WebsocketClient } from 'src/app/common/service/websocket-client.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { StoreContent } from 'src/app/store/model/store-model';
import { StoreService } from 'src/app/store/service/store.service';
import { Notification, NOTIFICATIONS_STORE_NAME } from '../../../common/model/notification';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit, OnDestroy {

  notifications: Notification[];
  currentRoute: string;
  hasApps: boolean;

  // Tyle animacja czeka na render nowego widoku. Bez tego przy ciężkim module (SAKP, Pojazdy)
  // zatwierdzenie przejścia trafia w to samo długie zadanie co render i cały czas przejścia
  // upływa przed pierwszą klatką - zostaje przeskok.
  private static readonly viewSettleMs = 250;

  private notificationSubscription: Subscription;
  private routerSubscription: Subscription;
  private appsStateTimeout: ReturnType<typeof setTimeout>;

  constructor(public langService: LangService, public userProfileService: UserProfileService, public websocket: WebsocketClient,
    private storeService: StoreService, public userSettings: UserSettingsService, private router: Router,
    private avatarService: AvatarService) { }

  ngOnInit(): void {
    if (!this.storeService.isStorageTypeExists(NOTIFICATIONS_STORE_NAME)) {
      this.storeService.addStorageType(NOTIFICATIONS_STORE_NAME, new StoreContent<Notification>((notification: Notification) => notification.time.getTime()));
    }
    this.notificationSubscription = this.storeService.connectToAllDataUpdates<Notification>(NOTIFICATIONS_STORE_NAME)
      .pipe(map(notifications => orderBy(notifications, (notification: Notification) => notification.time, ['desc'])))
      .subscribe(notifications => this.notifications = notifications
      );
    this.currentRoute = this.router.url;
    this.hasApps = !isHomeUrl(this.currentRoute);
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.updateAppsState(event.url);
      } else if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.updateAppsState(this.currentRoute);
      }
    });
  }

  ngOnDestroy(): void {
    this.notificationSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    clearTimeout(this.appsStateTimeout);
  }

  private updateAppsState(url: string): void {
    clearTimeout(this.appsStateTimeout);
    if (isHomeUrl(url)) {
      // Home jest tani w renderze, więc chowanie może ruszyć od razu.
      this.hasApps = false;
    } else {
      this.appsStateTimeout = setTimeout(() => this.hasApps = true, TopBarComponent.viewSettleMs);
    }
  }

  clearNotifications(): void {
    this.storeService.clear(NOTIFICATIONS_STORE_NAME);
    this.notifications = null;
  }

  deleteNotification(notification: Notification): void {
    this.storeService.delete(NOTIFICATIONS_STORE_NAME, notification);
  }

  reconnectFromDot(event: MouseEvent, isConnected: boolean): void {
    if (!isConnected) {
      event.stopPropagation();
      this.websocket.connectToWebsocket();
    }
  }

  downloadInstruction(): void {
    window.open('assets/downloads/instrukcja.pdf', '_blank');
  }

  get managementEnabled(): boolean {
    return this.userProfileService.isService() || this.userProfileService.isAdmin();
  }

  getAvatarColor(): string {
    return this.avatarService.colorOf(this.userProfileService.getUserName());
  }

}

function isHomeUrl(url: string): boolean {
  return url === '/home';
}
